module.exports = __webpack_public_path__ + "img/vinos_baja_california.b35314f8.jpg";